import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  Chip,
} from "@mui/material";
import SpeedIcon from "@mui/icons-material/Speed";
import PaletteIcon from "@mui/icons-material/Palette";
import DevicesIcon from "@mui/icons-material/Devices";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Link } from "react-router-dom";
import { ApiFetch } from "../context/Api";

const features = [
  {
    icon: <SpeedIcon fontSize="large" color="primary" />,
    title: "Rendimiento",
    desc: "React 18 con concurrent features para una experiencia ultra fluida.",
  },
  {
    icon: <PaletteIcon fontSize="large" color="secondary" />,
    title: "Diseño",
    desc: "Material UI 7 con temas personalizados y componentes listos para producción.",
  },
  {
    icon: <DevicesIcon fontSize="large" color="primary" />,
    title: "Responsivo",
    desc: "Totalmente adaptado a móvil, tablet y escritorio usando el sistema de grid de MUI.",
  },
  {
    icon: <CloudUploadIcon fontSize="large" color="secondary" />,
    title: "Deploy listo",
    desc: "Configurado para Vercel con routing SPA incluido desde el primer commit.",
  },
];

export default function Home() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [pubgender, setPubgender] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const res = await ApiFetch.get("/cat/pubgen");
      if (!res) {
        throw new Error("Token inválido o expirado");
      }

      setPubgender(res);

    } catch (error) {
      setPubgender([]);
    } finally {
      setLoading(false);
    }
  };



  return (
    <Box>
      <Typography>
        API URL: {apiUrl}
      </Typography>
      <Box
        sx={{
          background: "linear-gradient(135deg, #1a237e 0%, #283593 50%, #00bcd4 100%)",
          color: "white",
          py: { xs: 8, md: 14 },
          px: 2,
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: -1,
            left: 0,
            right: 0,
            height: 60,
            background: "var(--mui-palette-background-default, #f5f7ff)",
            clipPath: "ellipse(55% 100% at 50% 100%)",
          },
        }}
      >
        <Chip label="React 18 + MUI 7" variant="outlined" sx={{ color: "white", borderColor: "rgba(255,255,255,0.5)", mb: 3 }} />
        <Typography variant="h2" component="h1" sx={{ fontWeight: 800, mb: 2, fontSize: { xs: "2rem", md: "3.5rem" } }}>
          Tu proyecto, listo para{" "}
          <Box component="span" sx={{ color: "#62efff" }}>
            producción
          </Box>
        </Typography>
        <Typography variant="h6" sx={{ maxWidth: 560, mx: "auto", mb: 4, opacity: 0.85, fontWeight: 400 }}>
          Base sólida con React 18, MUI 7, React Router y deploy en Vercel con un solo clic.
        </Typography>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
          <Button variant="contained" color="secondary" size="large" component={Link} to="/about">
            Ver más
          </Button>
          <Button
            variant="outlined"
            size="large"
            sx={{ color: "white", borderColor: "rgba(255,255,255,0.5)", "&:hover": { borderColor: "white", background: "rgba(255,255,255,0.1)" } }}
            component={Link}
            to="/contact"
          >
            Contacto
          </Button>
        </Box>
      </Box>

      {/* Features */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container
          spacing={3}
          justifyContent="center"
          alignItems="center">
          {loading && <p>Cargando...</p>}
          {pubgender.map((f) => (
            <Grid item xs={12} sm={6} md={3} key={f.pubgen_id}>
              <Card sx={{ height: "100%", p: 1 }}>
                <CardContent sx={{ textAlign: "center" }}>
                  <Typography variant="h6" fontWeight={700} mb={1}>
                    {f.pubgen_id}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {f.pubgen_description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Typography p={5} variant="h4" textAlign="center" fontWeight={700} mb={1}>
          ¿Qué incluye?
        </Typography>
        <Typography variant="body1" textAlign="center" color="text.secondary" mb={6}>
          Todo lo que necesitas para arrancar rápido.
        </Typography>
        <Grid container spacing={3}>
          {features.map((f) => (
            <Grid item xs={12} sm={6} md={3} key={f.title}>
              <Card sx={{ height: "100%", p: 1 }}>
                <CardContent sx={{ textAlign: "center" }}>
                  <Box sx={{ mb: 2 }}>{f.icon}</Box>
                  <Typography variant="h6" fontWeight={700} mb={1}>
                    {f.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {f.desc}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
